import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Header.module.scss';
import { clickTracker } from '../../../lib/common';
import useClickAwayListener from '../../../hooks/useClickAwayLitsner';
import { genEditListingToken, sendCommunicationCS } from '../../../api';
import useAlert from '../../../hooks/useAlert';
import { server } from '../../../config';
import { usePopup } from '../../../hooks';
import Tooltip from '../Tooltip/Tooltip';
import { logInfo } from '../../../lib/logTrace';

const GenioHeader = ({ pageType }) => {
  const navigate = useNavigate();
  const [tooltip, setTooltip] = useState(true);
  const sessionStorageTooltip = JSON.parse(sessionStorage.getItem('Tooltip'));
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio')) || {};
  const contractType = sessionStorage.getItem('contractType');
  const dropDownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [setAlert] = useAlert();
  const [setPopup] = usePopup();
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const location = useLocation();
  const faqType = location.pathname.replace('/genio/faq', '').replace('/', '') || '';
  const headersObj = {
    leads: 'Leads',
    ecs: 'ECS',
    payment_history: 'Payments History',
    contract: 'My Contract Information',
    payments: 'Payments & Invoices',
    edit_business: 'Edit My Business',
    Healthcare: 'Healthcare',
    website_app_related: 'Website App Related',
    jd_pay: 'JD Pay',
    grievanceRedressal: 'Grievance Redressal',
    category_create_ticket: 'Raise a Complaint',
    create_ticket: 'Raise a Complaint',
  };
  const hasPath = ['website_app_related', 'jd_pay'].includes(faqType);
  const hasSelfServePath = ['ecs', 'payments', 'leads', 'contract', 'edit_business'].includes(pageType);
  const headerTitle = hasPath ? headersObj[faqType] || '' : headersObj[pageType] || '';

  useClickAwayListener(dropDownRef, () => {
    setShowDropdown(false);
  });

  const dropDownItems = [{ type: 'shareLink', title: 'Share Link', icon: styles.dropshare__icon }];
  if (['expiredLong', 'free'].includes(contractType)) {
    dropDownItems.push({ type: 'editIcon', title: 'Edit Listing', icon: styles.dropedit__icon });
  }
  if (['paid', 'expiredShort'].includes(contractType)) {
    dropDownItems.push({ type: 'createTicket', title: 'Create Ticket', icon: styles.createTicket__icon });
  }

  const showShareLink = hasSelfServePath || hasPath;

  const handleGoBack = () => {
    if (window.location.pathname.includes('features')) {
      localStorage.removeItem('selectedBusinessGenio');
    }
    if (pageType === 'landing') {
      window.close();
    }
    navigate(-1);
    return null;
  };

  const editBusinessId = false;
  const handleEditListing = async () => {
    await clickTracker('sharelink', `${pageType}`);

    if (selectedBusinessGenio?.mobile) {
      if (editBusinessId) {
        setShowDropdown((prev) => !prev);
      } else {
        try {
          const params = {
            ...selectedBusinessGenio,
            shareLinkType: showShareLink
              ? pageType === 'edit_business'
                ? 'editBusinessLink'
                : 'leadsLink'
              : 'landingShareLink',
            faqType: showShareLink ? (hasSelfServePath ? pageType : faqType) : '',
          };
          const response = await sendCommunicationCS(params);
          setAlert({
            message: response?.errorCode === 0 ? response?.result : response?.message || 'Message not sent',
            status: response?.errorCode === 0,
          });
        } catch (err) {
          console.log('err sendCommunicationCS', err);
        }
      }
    } else {
      setAlert({
        message: 'No Mobile number found in the contract.',
        status: false,
      });
    }
  };

  const handleDropdownItemClick = async (type) => {
    if (type === 'editIcon') {
      try {
        const params = {
          eid: profile?.empCode || '',
          docId: selectedBusinessGenio?.docId || '',
          city: selectedBusinessGenio?.city || '',
          mobile: profile?.mobile || '',
          empName: profile?.full_name || '',
          backUrl: encodeURI(window.location.href),
        };
        const genioFlag = 1;
        const { token, closedDown } = await genEditListingToken(params, genioFlag);
        if (closedDown) {
          // setAlert({
          //   message: 'Contract is marked as closed!',
          //   status: false,
          // });
          return;
        }
        const url = `${server.editListingRedirectionUrl}?tid=${token}&eid=${profile?.empCode}&salesEmp=1&user_type=TME&isandroid=0&sso_dept=SALES&team_type=HD&typeOfEmployee=tme&vertical=genioCS`;
        window.open(url, '_self');
      } catch (err) {
        setAlert({
          message: 'Something went wrong!',
          status: false,
        });
      }
    } else if (type === 'shareLink') {
      setPopup({
        open: true,
        popupType: 'shareLinkPopup',
      });
    } else if (type === 'createTicket') {
      if (selectedBusinessGenio?.parentId && selectedBusinessGenio?.city) {
        navigate(
          `/genio/create_ticket?parentId=${selectedBusinessGenio?.parentId}&city=${selectedBusinessGenio?.city}&key=edit_my_business`,
        );
      }
    }
  };

  useEffect(() => {
    if (profile) {
      logInfo({
        url: window.location.href,
        empId: profile?.empCode,
      });
    }
  }, [location.pathname, profile?.empCode]);

  useEffect(() => {
    setTimeout(() => {
      setTooltip(false);
      sessionStorage.setItem('Tooltip', 1);
    }, 3000);
  }, []);

  return (
    <>
      <header className={`${styles.header_box} ${styles.header_blue} `}>
        <div className={`${styles.header_left}`}>
          <div
            aria-label="header_back_btn"
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            className={`csicon ${styles.page_whiteback_icon} `}
            id="headerback"
            onClick={() => handleGoBack()}
          />
        </div>
        <div className={`${styles.header_center}`}>
          <div className={`${styles.header_text} text_center`}>
            {selectedBusinessGenio && Object.keys(selectedBusinessGenio)?.length > 0 ? (
              <div className="csheader_text text_center">
                <div className="font14 fw600 colorFFF">
                  {headerTitle && <div>{headerTitle}</div>}
                  <div>
                    <Tooltip
                      text={selectedBusinessGenio.companyName?.length > 20 ? selectedBusinessGenio.companyName : ''}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <div
                          className={`${selectedBusinessGenio.companyName?.length > 20 ? 'business-title-header' : ''}`}
                        >
                          {selectedBusinessGenio.companyName}
                        </div>
                      </div>
                    </Tooltip>
                  </div>
                  {pageType === 'features' && (
                    <div className="font11 fw400 colorFFF">{selectedBusinessGenio?.location || ''}</div>
                  )}
                </div>
              </div>
            ) : (
              <div className="font14 fw600 colorFFF text-center">Customer Support</div>
            )}
          </div>
        </div>
        {pageType === 'landing' && (
          <div className={`${styles.header_right}`}>
            {tooltip && !sessionStorageTooltip && (
              <>
                <div className={`${styles.tooltip_header}`}>
                  <div className="font12 fw400 colorFFF">Ticket History</div>
                </div>
              </>
            )}
            <div
              aria-label="genio_myTickets_click"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              onClick={async () => {
                await clickTracker('mytickets', 'geniocs');
                navigate('/genio/myTickets');
              }}
              className="csicon myTickets_icon"
            />
          </div>
        )}
        {(pageType === 'features' || showShareLink) && (
          <div className={`${styles.header_right}`} ref={dropDownRef}>
            <div
              aria-label="editlisting_click"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              className="csicon csheader_box genio-header-share-icon"
              onClick={() => handleEditListing()}
            />
            {showDropdown && (
              <ul className={`${styles.dropdown__list} edit-business-dropdown`}>
                {dropDownItems.map((each, i) => (
                  <li key={i} className={`${styles.dropdown__item} whitefill_animate`}>
                    <div
                      style={{ display: 'flex', alignItems: 'center' }}
                      tabIndex={0}
                      role="button"
                      onKeyDown={() => {}}
                      onClick={() => handleDropdownItemClick(each.type)}
                    >
                      <div className={`${each.icon} ${styles.dropitem__icon} csicon`} />
                      <div className={`${styles.dropitem__text} pl-8 font14 fw500 color111`}>{each.title}</div>
                    </div>
                  </li>
                ))}
              </ul>
            )}

            {tooltip && (
              <>
                <div className={`${styles.tooltip_header}`}>
                  <div className="font12 fw400 colorFFF">{editBusinessId ? 'Edit Business' : 'Share support link'}</div>
                </div>
              </>
            )}
          </div>
        )}
      </header>
    </>
  );
};

export default GenioHeader;

GenioHeader.propTypes = {
  pageType: PropTypes.string,
};
